// Bridge for HAR-1808 bulk SUCCESS-on-chunk-upload — Rust cannot read
// Flagsmith, so the FE pushes the value; managed state defaults to false.
import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';

export async function setBulkSuccessOnChunkUploadEnabled(
  enabled: boolean
): Promise<void> {
  if (!isTauri()) return;
  try {
    // eslint-disable-next-line @heidi/rules/no-new-direct-tauri-import -- no guest-js bridge for chronicle flag push yet (HAR-1808)
    const { invoke } = await import('@tauri-apps/api/core');
    await invoke<void>('chronicle_set_bulk_success_on_chunk_upload_enabled', {
      enabled,
    });
  } catch (error) {
    logger.error('[bulkSuccessOnChunkUpload] Failed to push flag to Rust:', error);
  }
}
